export const formatMeters = (meters: number) => {
  if (meters < 1000) return `${Math.round(meters)} m`
  return `${Math.round(meters / 10) / 100} km`
}

export const formatSpeed = (speedInKmh: number) => `${speedInKmh} kmh`
